module.exports = __webpack_public_path__ + "static/media/shape_2.d44366df.svg";